<template>
  <div class="uploader-container d-flex align-item-end">
    <div
      v-if="uploadImage.url"
      :style="renderImageUrl"
      :class="type == 'cover' ? 'image-area-no-border' : 'result-image-review'"
      @click="onUpload"
    >
      <div class="result-image-review-replace-hover">
        <b-button class="upload-button-hover bypass">
          <div class="d-flex align-items-center">
            <upload-icon class="mr-3 image-upload-icon" />
            <span>{{
              "Replace"
            }}</span>
          </div>
        </b-button>
      </div>
    </div>
    <div
      v-else
      :style="renderImageUrl"
      class="result-image-area"
      @click="onUpload"
    ></div>
    <input
      ref="refInputEl"
      type="file"
      class="d-none"
      accept="image/*"
      @change="handleUploadChange"
    />
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
import useImageUploader from "./hooks/useImageUploader";

export default {
  components: { BButton, UploadIcon },

  props: {
    imageUrl: String,
    type: String,
    isRequired: { type: Boolean, default: false },
  },

  setup(props) {
    const {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    } = useImageUploader(props);

    return {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/override-styles/image-uploader.css";
@import "~@/assets/css/override-styles/question-image-uploader.css";
</style>
